import React from 'react';

export default class AppMain extends React.Component {
	render() {
		return <main className="app-body">{this.props.children}</main>;
	}
}
